import { ActivatedRoute, Router } from '@angular/router';
import { SolicitacaoTecnicaService } from './../../../../services/solicitacao-tecnica.service';
import { ISolicitacaoTecnicaModel } from './../../../../models/solicitacao-tecnica.model';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-imprimir-solicitacao',
  templateUrl: './imprimir-solicitacao.component.html',
  styleUrls: ['./imprimir-solicitacao.component.scss']
})
export class ImprimirSolicitacaoComponent implements OnInit {

  public model: ISolicitacaoTecnicaModel = {} as ISolicitacaoTecnicaModel;
  constructor(
    public serviceSolicitacao: SolicitacaoTecnicaService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    this.model.id = Number(this.route.snapshot.paramMap.get('solicitacaotecnicaId'));
  }

  ngOnInit(): void {
    this.obterPorId()
  }

  public obterPorId() {
    this.serviceSolicitacao.obterPorId(this.model?.id).then((res) => {
      if (res.sucesso) {

        this.model = res.dados

      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  formatarCpfCnpj(valor: string): string {
    if (!valor) return '';

    const digits = valor.replace(/\D/g, '');

    if (digits.length <= 11) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
  }

  formatarTelefone(digits: string): string {
    if (!digits) return '';

    const apenasNumeros = digits.replace(/\D/g, '');

    if (apenasNumeros.length === 11) {
      // Celular: (00) 00000-0000
      return apenasNumeros.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    } else if (apenasNumeros.length === 10) {
      // Fixo: (00) 0000-0000
      return apenasNumeros.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }

    return apenasNumeros; // Retorna só os dígitos se não bater com formatos esperados
  }


  public cancelar() {
    window.history.back()
  }

  public print() {
    window.print();
  }
}
